



















import Vue from "vue";
export default Vue.extend({
  name: "SelectedFiltersChip",
  props: {
    filterTypeName: { type: String, required: true },
    seletedFilters: { type: Array, required: false },
    clearText: { type: String, required: true },
  },
  methods: {
    onClickClearIcon() {
      this.$emit("clear");
    },
  },
});
